module.exports = __webpack_public_path__ + "img/4.625edc81.jpg";